import type {ReactNode} from 'react'
import {LockIcon} from '@primer/octicons-react'
import styles from './BlockedTaskInput.module.css'

interface BlockedTaskInputProps {
  /** The message to display explaining why input is blocked */
  children: ReactNode
}

/**
 * Presentational component for displaying a blocked/disabled state in chat inputs.
 * Shows a lock icon alongside a message explaining why input is unavailable.
 */
export function BlockedTaskInput({children}: BlockedTaskInputProps) {
  return (
    <div className={styles.blockedContainer}>
      {/* Focusable by script only, never in the tab order. This state replaces
          the composer, so it has to be able to receive focus when a neighbouring
          control unmounts and would otherwise drop focus to the document. */}
      <div className={styles.blockedContent} data-testid="blocked-task-input" tabIndex={-1}>
        <LockIcon size={16} className={styles.blockedIcon} />
        <p className={styles.blockedText}>{children}</p>
      </div>
    </div>
  )
}
